//存放课程编排页面的筛选项

// initial state
const state = () => ({
  //等级筛选
  level: null,
  //课程位置筛选
  num: null,
  //搜索关键字
  search: '',
})

// getters
const getters = {
  getPos(state) {
    return `${state.level}-${state.num}`
  }
}

// actions
const actions = {

}

// mutations
const mutations = {

  setLevel(state, level) {
    state.level = level
  },

  setNum(state, num) {
    state.num = num
  },

  setPos(state, pos) {
    let matches = /L?(\d+)-(\d+)/.exec(pos)
    if (matches && matches[1]) {
      state.level = Number.parseInt(matches[1])
    }
    if (matches && matches[2]) {
      state.num = Number.parseInt(matches[2])
    }
  },

  setSearch(state, wd) {
    state.search = wd
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}